import React from 'react';
import { CheckIcon } from 'lucide-react';
interface Option {
  value: string;
  label: string;
  description?: string;
}
interface CheckboxGroupProps {
  options: Option[];
  values: string[];
  onChange: (values: string[]) => void;
  className?: string;
  columns?: 1 | 2 | 3;
}
export function CheckboxGroup({
  options,
  values,
  onChange,
  className = '',
  columns = 1
}: CheckboxGroupProps) {
  const gridCols = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-3'
  };
  const toggleValue = (val: string) => {
    if (values.includes(val)) {
      onChange(values.filter(v => v !== val));
    } else {
      onChange([...values, val]);
    }
  };
  return <div className={`grid gap-3 ${gridCols[columns]} ${className}`} data-id="element-601">
      {options.map(option => {
      const isSelected = values.includes(option.value);
      return <button key={option.value} type="button" onClick={() => toggleValue(option.value)} className={`relative flex flex-col items-start p-4 text-left transition-all duration-200 border-2 rounded-xl w-full ${isSelected ? 'border-[#007AFF] bg-[#F0F7FF] shadow-[inset_0_0_0_1px_#007AFF]' : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50'}`} data-id="element-602">
            <div className="flex items-center justify-between w-full" data-id="element-603">
              <span className={`font-semibold text-sm transition-colors duration-200 ${isSelected ? 'text-[#007AFF]' : 'text-gray-900'}`} data-id="element-604">
                {option.label}
              </span>
              <div className={`flex items-center justify-center w-5 h-5 rounded border-2 flex-shrink-0 ml-3 transition-all duration-200 ${isSelected ? 'border-[#007AFF] bg-[#007AFF]' : 'border-gray-300'}`} data-id="element-605">
                {isSelected && <CheckIcon className="w-3 h-3 text-white" data-id="element-606" />}
              </div>
            </div>
            {option.description && <span className={`text-xs mt-1.5 transition-colors duration-200 ${isSelected ? 'text-[#005FCC]' : 'text-gray-500'}`} data-id="element-607">
                {option.description}
              </span>}
          </button>;
    })}
    </div>;
}